import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
import { _, _all } from './modules/dom';

const sliderClass = '.we-block-slider';
const wrapperClass = `${sliderClass}__slides`;

_all(sliderClass).forEach(slider => {
    const slides = _(wrapperClass, slider);

    if (slides) {
        const options = {
            modules: [ Navigation, Pagination, Autoplay, EffectFade ],
        };

        if (slider.dataset.sliderLoop == 'true') {
            options.loop = true;
        }

        if (slider.dataset.sliderAutoplayDelay) {
            options.autoplay = {
                delay: Number(slider.dataset.sliderAutoplayDelay),
            };
        }

        const effect = slider.dataset.sliderEffect;
        if (effect == 'fade') {
            options.effect = 'fade';
            options.fadeEffect = { crossFade: true };
        }

        // console.log(options);
        new Swiper(slider, options);
    }
});

_all('.wb-swiper').forEach(swiper => {

    const options = getOptions(swiper);


    // console.log(swiper, options);
    new Swiper(swiper, getOptions(swiper));
});

function getOptions(e) {
    const options = { };
    const pcOptions = { };
    const tabOptions = { };
    const spOptions = { };
    let isSmartphone = false;
    let isTablet = false;

    if (e.dataset.swiperAutoplay) {
        options.autoplay = ( Number(e.dataset.swiperAutoplay) * 1000 );
    }

    if (e.dataset.swiperLoop == '1') {
        options.loop = true;
    }

    if (e.dataset.swiperSpeed) {
        options.speed = ( Number(e.dataset.swiperSpeed) );
    }



    if (e.dataset.swiperPerView) {
        pcOptions.slidesPerView = Number(e.dataset.swiperPerView);
    }

    if (e.dataset.swiperCenter) {
        pcOptions.centeredSlides = e.dataset.swiperCenter == '1';
    }

    if (e.dataset.swiperSpaceBetween) {
        pcOptions.spaceBetween = Number(e.dataset.swiperSpaceBetween);
    }



    if (e.dataset.swiperTabPerView) {
        isTablet = true;
        tabOptions.slidesPerView = Number(e.dataset.swiperTabPerView);
    }

    if (e.dataset.swiperTabCenter) {
        isTablet = true;
        tabOptions.centeredSlides = e.dataset.swiperTabCenter == '1';
    }

    if (e.dataset.swiperTabSpaceBetween) {
        isTablet = true;
        tabOptions.spaceBetween = Number(e.dataset.swiperTabSpaceBetween);
    }



    if (e.dataset.swiperSpPerView) {
        isSmartphone = true;
        spOptions.slidesPerView = Number(e.dataset.swiperSpPerView);
    }

    if (e.dataset.swiperSpCenter) {
        isSmartphone = true;
        spOptions.centeredSlides = e.dataset.swiperSpCenter == '1';
    }

    if (e.dataset.swiperSpSpaceBetween) {
        isSmartphone = true;
        spOptions.spaceBetween = Number(e.dataset.swiperSpSpaceBetween);
    }

    if (isSmartphone || isTablet) {
        options.breakpoints = { };
    }

    if (isSmartphone) {
        Object.assign(options, spOptions);

        if (isTablet) {
            options.breakpoints[520] = tabOptions;
        }

        options.breakpoints[960] = pcOptions;
    } else if (isTablet) {
        Object.assign(options, tabOptions);
        options.breakpoints[960] = pcOptions;
    } else {
        Object.assign(options, pcOptions);
    }

    console.log(options, tabOptions, spOptions);
    return options;
}
